import React, { useState, useEffect, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import "./ProjectCards.css";

function ProjectCards(props) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isInteracting, setIsInteracting] = useState(false);
  const timeoutRef = useRef(null);

  const imgPaths = props.imgPaths || [];

  useEffect(() => {
    if (!isInteracting && imgPaths.length > 1) {
      timeoutRef.current = setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imgPaths.length);
      }, 3000);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [currentIndex, isInteracting, imgPaths.length]);

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
    setIsInteracting(true);
    setTimeout(() => setIsInteracting(false), 5000);
  };

  return (
    <Card className="project-card-view">
      <Card.Body>
        <div
          className="carousel-container"
          onMouseEnter={() => setIsInteracting(true)}
          onMouseLeave={() => setIsInteracting(false)}
        >
          <div
            className="carousel-slide"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {imgPaths.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Slide ${index}`}
                className="carousel-image"
              />
            ))}
          </div>

          {imgPaths.length > 1 && (
            <div className="carousel-indicators">
              {imgPaths.map((_, index) => (
                <div
                  key={index}
                  className={`indicator-dot ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => handleIndicatorClick(index)}
                />
              ))}
            </div>
          )}
        </div>
        
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {props.ghLink && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        )}

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
